module.exports = __webpack_public_path__ + "static/Advantage05@1x.8edb401d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Advantage05@1x.png
// module id = 695
// module chunks = 216210090109534